module.exports = __webpack_public_path__ + "img/atlas-logo.996ce718.png";